<template>
  <div class="sketch_parent">
    <div class="wrapper">
      <div class="sketch_main2">
        <div class="sketch_up_title">入力内容を確認してください。</div>
      </div>
      <section class="input_confirm3 sketch_confirm">
        <ul>
          <li>
            <div>お客様のID</div>
            <div>{{userInfo.email}}</div>
          </li>
          <li>
            <div>御氏名</div>
            <div>{{userInfo.userLastName}} {{userInfo.userFirstName}}</div>
          </li>
          <li>
            <div>お問い合わせ番号</div>
            <div>{{sketchForm.tel}}</div>
          </li>
          <li>
            <div>アップロード内容1</div>
            <div>{{sketchForm.viewUploadFilesName1}}</div>
          </li>
          <li>
            <div>アップロード内容2</div>
            <div>{{sketchForm.viewUploadFilesName2}}</div>
          </li>
          <li>
            <div>アップロード内容3</div>
            <div>{{sketchForm.viewUploadFilesName3}}</div>
          </li>
          <li>
            <div>アップロード内容4</div>
            <div>{{sketchForm.viewUploadFilesName4}}</div>
          </li>
          <li>
            <div>アップロード内容5</div>
            <div>{{sketchForm.viewUploadFilesName5}}</div>
          </li>
          <li>
            <div>お届け先郵便番号</div>
            <div>{{sketchForm.deliveryPostcd}}</div>
          </li>
          <li>
            <div>組立設置サービス</div>
            <div v-if="sketchForm.isConstruct===true">あり</div>
            <div v-if="sketchForm.isConstruct===false">なし</div>
          </li>
          <li>
            <div>組立設置先</div>
            <div>{{sketchForm.constructPostcd}}</div>
          </li>
          <li>
            <div>受け入れ搬入</div>
            <div v-if="sketchForm.isCarryFlag===true">あり</div>
            <div v-if="sketchForm.isCarryFlag===false">なし</div>
          </li>
          <li>
            <div>コメント</div>
            <div>{{sketchForm.comment}}</div>
          </li>
        </ul>
      </section>
    </div>
    <div class="sketch_order_footer">
      <div class="sketch_order_next_btn" @click="send">送信</div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      sketchForm: {},
      sendFlag: false,
      userInfo: {}
    }
  },
  computed: {
  },
  methods: {
    send: function () {
      this.$refs.loadingModalRef.showModal(true)
      this.sendFlag = true
      axios.get(DC_URL.SKETCH + '/confirm')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.sendFlag = false
            this.$router.push({
              name: 'DcSketchUploadComplete'
            })
            this.$refs.loadingModalRef.showModal(false)
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
        })
    }
  },
  mounted: function () {
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.sketchForm = App.getLocalStorage(DC_STORAGE_KEY.SKETCH_ORDER)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style src="../css/dc-sketch.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSketchUploadConfirm.vue